import styled from 'styled-components'
import { colors, device } from 'Styled/variables'

const getColor = (value: number, isMissed: boolean) => {
  if (value <= 20) {
    return isMissed ? colors.green : colors.messegesRed
  }
  if (value <= 80) {
    return colors.messegesYellow1
  }
  return isMissed ? colors.messegesRed : colors.green
}

export const Container = styled.div`
  padding: 13px 16px;
  width: 24%;
  height: 128px;
  background: ${colors.white};
  border-radius: 4px;

  @media screen and ${device.mobileMax} {
    margin-bottom: 10px;
    width: 228px;
  }

  @media screen and ${device.smallScreenMax} {
    height: auto;
  }
`

export const Title = styled.p`
  margin: 0;
  font-size: 14px;
  line-height: 21px;
  font-weight: 400;
  color: ${colors.greyTextWhiteBg} !important;

  @media screen and ${device.smallScreenMax} {
    height: 45px;
  }
`

export const Value = styled.p`
  margin-top: 7px;
  font-size: 20px;
  line-height: 30px;
  font-weight: 600;
  color: ${colors.mainText};
`

export const SubValue = styled.p<{ value?: number; isMissed?: boolean }>`
  margin-top: 7px;
  font-size: 14px;
  line-height: 21px;
  font-weight: 400;
  color: ${({ value, isMissed }) =>
    value && isMissed && getColor(value, isMissed)} !important;
`

export const DataCollectedLabel = styled.p`
  margin: 0;
  font-size: 10px;
  line-height: 15px;
  font-weight: 400;
  color: ${colors.mainText};
`
